// src/components/RouteLoading.tsx
import React, { useEffect, useRef, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { Backdrop, Box, Typography, useTheme } from '@mui/material';
import SchoolRoundedIcon from '@mui/icons-material/SchoolRounded';
import { keyframes } from '@mui/system';

const pop = keyframes`
  0% { transform: scale(0.9); opacity: .9; }
  50% { transform: scale(1.06); opacity: 1; }
  100% { transform: scale(0.9); opacity: .9; }
`;

const slowSpin = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`;

// rotas nas quais o overlay NÃO deve aparecer
const EXCLUDE = new Set<string>(['/home', '/faq']);

export default function RouteLoading() {
  const theme = useTheme();
  const { pathname } = useLocation();
  const [open, setOpen] = useState(false);
  const hideTimer = useRef<number | null>(null);

  useEffect(() => {
    // normaliza removendo barra final ("/faq/") -> "/faq"
    const normalized =
      pathname.replace(/\/+$/, '') === '' ? '/' : pathname.replace(/\/+$/, '');

    // limpa timer pendente
    if (hideTimer.current) window.clearTimeout(hideTimer.current);

    // se estiver na lista de exclusão, garante que não abra
    if (EXCLUDE.has(normalized.toLowerCase())) {
      setOpen(false);
      return;
    }

    // caso normal: mostra o overlay e fecha após ~600ms
    setOpen(true);
    hideTimer.current = window.setTimeout(() => setOpen(false), 600);

    return () => {
      if (hideTimer.current) window.clearTimeout(hideTimer.current);
    };
  }, [pathname]);

  return (
    <Backdrop
      open={open}
      sx={{
        zIndex: theme.zIndex.modal + 1,
        color: '#fff',
        backdropFilter: 'blur(2px)',
        backgroundColor: 'rgba(6, 33, 63, 0.35)',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <Box
        sx={{
          position: 'relative',
          width: 96,
          height: 96,
          display: 'grid',
          placeItems: 'center',
        }}
      >
        {/* Anel decorativo */}
        <Box
          sx={{
            position: 'absolute',
            inset: 0,
            borderRadius: '50%',
            borderWidth: 3,
            borderStyle: 'solid',
            borderColor: 'rgba(255,255,255,0.2)',
            borderTopColor: 'currentColor',
            animation: `${slowSpin} 1.2s linear infinite`,
          }}
        />
        {/* Ícone educacional */}
        <SchoolRoundedIcon
          sx={{
            fontSize: 44,
            animation: `${pop} 1.6s ease-in-out infinite`,
            filter: 'drop-shadow(0 4px 10px rgba(0,0,0,.35))',
          }}
        />
      </Box>
      <Typography sx={{ mt: 2, fontWeight: 600 }}>
        Carregando conteúdo...
      </Typography>
    </Backdrop>
  );
}
